import React from 'react';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { PluginComponent } from 'plugins';
import { modalPages as mp } from 'constants/modalPage';
import { openModalPage } from 'actions/modalPage';
import { getSetting } from 'reducers/configs/settings';

import './tableStats.css';

type DataType = {
  key: string;
  value: string | number | { value: string; fullValue: string };
}[];

/**
 * Display statistics in a small table
 */
const TableStats = ({
  dataHeaders,
  data,
  title = null,
  isCustomer = false,
  dataType,
}: {
  /** The headers for this table */
  dataHeaders: { key: string; value: string | number }[];
  /** The values for this table - should have the same shape as dataHeaders */
  data: DataType;
  /** The title of this table */
  title?: string | null;
  /** Determines the default icon that will be displayed in the user badge */
  isCustomer: boolean;
  dataType: string;
}) => {
  const isDark = useSelector(getSetting('touchpos_use_dark_theme'));
  const prefix = isCustomer ? 'customer' : 'employee';

  const displayTableHeaders = dataHeaders.map(({ key, value }) => (
    // eslint-disable-next-line prefer-template
    <th
      key={`header-${dataType}-${key}`}
      style={{
        width: `${100 / dataHeaders.length}%`,
      }}
    >
      {value}
    </th>
  ));

  const displayTableStats = data.map(({ key, value: val }) => {
    let value = val;
    let fullValue = val;
    if (typeof val === 'object') {
      ({ value, fullValue } = val);
    }
    return (
      <td
        data-testid={`${prefix}-${dataType}-stats`}
        data-test-key={`${prefix}-${dataType}-${key}-${fullValue}`}
        key={`${prefix}-stat-${key}`}
        title={`${fullValue}`}
      >
        {value}
      </td>
    );
  });
  const dispatch = useDispatch();
  const showCustomer = () =>
    dispatch(openModalPage({ component: mp.customerView }));
  return (
    <PluginComponent hookname="UITableStats">
      <p className="statsTableTitle">{title}</p>
      <Table
        variant={isDark ? 'dark' : ''}
        size="sm"
        className="tableStats"
        onClick={
          isCustomer
            ? showCustomer
            : () => {
                // do nothing
              }
        }
      >
        <thead>
          <tr>{displayTableHeaders}</tr>
        </thead>
        <tbody>
          <tr>{displayTableStats}</tr>
        </tbody>
      </Table>
    </PluginComponent>
  );
};

export default TableStats;
